import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { services } from "../services";
import { draCourseIds } from "../config";

const FreezeWindow = () => {
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
  });
  const [latestFreeze, setLatestFreeze] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const fetchLatestFreezeWindow = async () => {
    try {
      const payload = { courseIds: draCourseIds };
      const res = await services.requestSvc.post(
        "/get-latest-freeze-window",
        payload,
      );
      console.log("ressss", res);
      if (res) {
        setLatestFreeze(res);
      }
    } catch (err) {
      console.error("❌ Error fetching latest freeze window:", err);
    }
  };
  useEffect(() => {
    fetchLatestFreezeWindow();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.fromDate || !formData.toDate) {
      toast.warn("Please select both From and To dates");
      return;
    }

    try {
      const payload = {
        fromDate: formData.fromDate,
        toDate: formData.toDate,
        courseIds: draCourseIds,
      };
      const success = await services.requestSvc.post(
        "/create-freeze-window",
        payload,
      );
      toast.success("Freeze window created successfully!");

      setFormData({ fromDate: "", toDate: "" });
      await fetchLatestFreezeWindow();
    } catch (err) {
      console.error("❌ Error saving freeze window:", err);
      toast.error("Failed to save freeze window");
    }
  };
  const formatDate = (isoDate) => {
    if (!isoDate) return "-";
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  return (
    <div className="min-h-screen bg-gray-100 p-10">
      <div className="bg-white rounded-xl shadow-md p-8 w-full mt-20">
        <h2 className="text-3xl font-semibold mb-8 text-center text-gray-800">
          Freeze Window
        </h2>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              From Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="fromDate"
              value={formData.fromDate}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">
              To Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="toDate"
              value={formData.toDate}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-200"
            />
          </div>

          <div className="md:col-span-2 flex justify-end mt-6">
            <button
              type="submit"
              className="btn-primary text-white font-semibold py-2 px-6 rounded-lg  md:w-1/4 hover:bg-blue-700 transition duration-200"
            >
              Freeze
            </button>
          </div>
        </form>
      </div>
      {latestFreeze?.freeze_history?.length > 0 ? (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
          <h3 className="text-lg font-semibold text-blue-700 mb-4">
            Last 5 Freeze Windows
          </h3>

          <div className="mb-4 p-3 bg-white rounded-lg shadow-sm border">
            <p className="text-gray-800 font-medium">
              <strong>Latest Freeze:</strong>
            </p>
            <p className="text-gray-700">
              <strong>From:</strong>{" "}
              {formatDate(latestFreeze.freeze_history[0]?.from)} &nbsp;
              <strong>To:</strong>{" "}
              {formatDate(latestFreeze?.freeze_history[0]?.to)}
            </p>

            {latestFreeze.updated_at && (
              <p className="text-gray-600 text-sm mt-1">
                Last Updated On:{" "}
                <span className="font-medium text-gray-800">
                  {formatDate(latestFreeze?.updated_at)}
                </span>
              </p>
            )}
          </div>
          <div className="space-y-2">
            {latestFreeze?.freeze_history.map((freeze, index) => (
              <div
                key={index}
                className="p-3 bg-white rounded-md border text-sm"
              >
                <p>
                  <strong>From:</strong> {formatDate(freeze?.from)} &nbsp;
                  <strong>To:</strong> {formatDate(freeze?.to)}
                </p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p className="text-gray-500 mb-6">No freeze window set yet.</p>
      )}
    </div>
  );
};

export default FreezeWindow;
